import { Button, DesktopWindowsOutlinedIcon } from '@shared/components';
import { useDisclosure } from '@shared/hooks';
import { useLogger } from '@shared/logger';

import { ExamRoomPreviewSettingsFormModal } from '../exam-room-preview-settings-form-modal';

interface ExamRoomPreviewButtonProps {
  subtaskId: string;
}

export default function ExamRoomPreviewButton(props: Readonly<ExamRoomPreviewButtonProps>) {
  const { subtaskId } = props;
  const logger = useLogger('ExamRoomPreviewButton');
  const [isModalOpen, { open: openModal, close: closeModal }] = useDisclosure(false);

  const handleClick = () => {
    logger.info('Exam Room Preview clicked for subtaskId:', subtaskId);
    openModal();
  };

  return (
    <>
      <Button
        startIcon={<DesktopWindowsOutlinedIcon />}
        variant='outlined'
        color='secondary'
        onClick={handleClick}
      >
        Exam Room Preview
      </Button>
      <ExamRoomPreviewSettingsFormModal
        open={isModalOpen}
        onClose={closeModal}
        subtaskId={subtaskId}
      />
    </>
  );
}
